import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CarCard = ({ vehicle, onSelect }) => {
  return (
    <div className="bg-white rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all duration-300 card-hover">
      <div className="flex flex-col md:flex-row items-center gap-6 p-6">
        <div className="w-full md:w-64 flex-shrink-0">
          <div className="aspect-[4/3] overflow-hidden bg-gradient-to-br from-teal-50 to-orange-50 rounded-lg">
            <Image
              src={vehicle?.image}
              alt={vehicle?.imageAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        
        <div className="flex-1 space-y-4">
          <div>
            <p className="text-sm text-muted-foreground uppercase tracking-wide mb-1">CAR TYPE</p>
            <h3 className="text-2xl font-heading font-bold text-foreground">
              {vehicle?.name}
            </h3>
          </div>
          
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2">
              <Icon name="Users" size={20} className="text-teal-600" />
              <span className="text-base text-foreground font-medium">{vehicle?.seats} Seats</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Briefcase" size={20} className="text-teal-600" />
              <span className="text-base text-foreground font-medium">{vehicle?.luggage} Luggage</span>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col items-center gap-4 md:border-l md:border-border md:pl-6">
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-teal-600">
              ₹{vehicle?.price?.toLocaleString('en-IN')}/-
            </p>
            <p className="text-xs text-muted-foreground mt-1">Inc. of Taxes & Toll*</p>
          </div>
          
          <Button
            variant="default"
            size="lg"
            onClick={onSelect}
            className="bg-gradient-to-r from-teal-600 to-orange-500 hover:from-teal-700 hover:to-orange-600 min-w-[160px]"
          >
            Book Now
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CarCard;